import { combineReducers } from "redux";
import account from "./account/reducer";
import orders from "./orders/reducer";
import Auth from "./auth/reducer";
// users

export default combineReducers({
  Auth,
  account,
  orders,
});
